export default __webpack_public_path__ + "static/media/soulectionradio001.4502a43f.JPG";